import { useEffect, useState } from "react";
import { _AdquisitionContract, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../../modules/theme/Component/usePaginator";
import { toast } from "react-toastify";
import { BasicPage } from "../../../../../../modules/theme/Component/BasicPage";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { InputDate } from "../../../../../../modules/theme/Input/InputDate";
import { ContractTypeEditor } from "../../../../../../modules/contract/select/ContractTypeEditor";
import { useNavigate } from "react-router-dom";

export const MyAdquisitionContract = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AdquisitionContract);
    const paginador = usePaginator();
    const navigate = useNavigate();

    const [filter, setFilter] = useState<any>({});
    const [FechaIni, setIFechaIni] = useState<number>(null)
    const [FechaOut, setIFechaOut] = useState<number>(null)
    const [year, setYear] = useState<number>(_single.getCurrenYear());

    useEffect(() => {
        getAdquisitionContractRender();
    }, [paginador.page])

    const getAdquisitionContractRender = () => {

        let x: any = {
            IDAccount: _single.getAccountID(),
            State: 1,
        }

        if (filter.IDAdquisitionItem > 0) {
            x.IDAdquisitionItem = filter.IDAdquisitionItem;
        }
        if (filter.Description?.length > 3) {
            x.Description = filter.Description;
        }
        if (filter.IDContractType > 0) {
            x.IDContractType = filter.IDContractType;
        }
        if (filter.ProjectName != '') {
            x.ProjectName = filter.ProjectName;
        }
        instance.getAdquisitionContractRenderReport(paginador.page, 15, x, FechaIni, FechaOut, year).then(
            (resp: any) => {
                setLista(resp.List)
            }
        ).catch(err => { toast.error(err) })
    }

    const clearFilter = () => {
        setIFechaIni(null)
        setIFechaOut(null)
        setFilter({ ...filter, IDContractType: null, Description: "" })
    }

    const navigateTO = (parameter: string) => {
        navigate(`/portal/home/${parameter}`);
    };

    const buildPages = () => {
        const result: number[] = [];
        const maxVisible = 5;

        let start = Math.max(1, paginador.page - 2);
        let end = Math.min(paginador.pages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            result.push(i);
        }

        return result;
    };

    return (
        <BasicPage titulo="Mis Contratos">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector onChange={setYear} />
                </div>

                <div className="col-md-3">
                    <InputDate
                        notDate={true}
                        name="desde"
                        label="Inicio"
                        value={FechaIni}
                        setDate={(e: any) => setIFechaIni(e)}
                    />
                </div>

                <div className="col-md-3">
                    <InputDate
                        notDate={true}
                        name="hasta"
                        label="Final"
                        value={FechaOut}
                        setDate={(e: any) => setIFechaOut(e)}
                    />
                </div>

                <div className="col-md-3">
                    <label>Necesidad</label>
                    <input
                        type="text"
                        className="form-control"
                        value={filter.Description}
                        onChange={(e) =>
                            setFilter({ ...filter, Description: e.target.value })
                        }
                    />
                </div>

                <div className="col-md-3">
                    <ContractTypeEditor
                        label={"Tipo Contrato"}
                        idSelector={filter.IDContractType}
                        onChange={(e) =>
                            setFilter({ ...filter, IDContractType: e })
                        }
                    />
                </div>

                <div className="col-md-6 d-flex align-items-end gap-2">
                    <button
                        className="btn btn-primary btn-sm px-4"
                        onClick={getAdquisitionContractRender}
                    >
                        <i className="ri-search-line me-1"></i>
                        Buscar
                    </button>

                </div>

                <div className="col-md-12">
                    {paginador.pages > 1 && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 6,
                                padding: "20px 0"
                            }}
                        >
                            <button
                                onClick={() => {
                                    if (paginador.page > 1)
                                        paginador.setPage(paginador.page - 1);
                                }}
                                disabled={paginador.page === 1}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: paginador.page === 1 ? "default" : "pointer",
                                    opacity: paginador.page === 1 ? 0.4 : 0.8,
                                    padding: "4px 8px"
                                }}
                            >
                                ◀
                            </button>

                            {buildPages().map((p) => (
                                <button
                                    key={p}
                                    onClick={() => paginador.setPage(p)}
                                    style={{
                                        border: "none",
                                        background:
                                            p === paginador.page
                                                ? "rgba(0,0,0,0.08)"
                                                : "transparent",
                                        cursor: "pointer",
                                        padding: "4px 8px",
                                        borderRadius: 4,
                                        fontWeight: p === paginador.page ? 600 : 400
                                    }}
                                >
                                    {p}
                                </button>
                            ))}

                            <button
                                onClick={() => {
                                    if (paginador.page < paginador.pages)
                                        paginador.setPage(paginador.page + 1);
                                }}
                                disabled={paginador.page === paginador.pages}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor:
                                        paginador.page === paginador.pages
                                            ? "default"
                                            : "pointer",
                                    opacity:
                                        paginador.page === paginador.pages ? 0.4 : 0.8,
                                    padding: "4px 8px"
                                }}
                            >
                                ▶
                            </button>
                        </div>
                    )}
                </div>

                <div className="col-md-12 mt-4">
                    <div className="row">
                        {lista?.length > 0 ? (
                            lista.map((contract: any, i: number) => {
                                const dataContract = contract.DataBeanProperties;

                                return (
                                    <div className="col-md-4 mb-3" key={i}>
                                        <div className="card shadow-sm h-100 p-3">

                                            {/* HEADER */}
                                            <div className="d-flex justify-content-between align-items-start">
                                                <h6 className="fw-bold mb-1">
                                                    {dataContract.InternalCode || "Sin código"}
                                                </h6>
                                                <span className="badge bg-primary">
                                                    {dataContract.ContractTypeName}
                                                </span>
                                            </div>

                                            {/* BODY */}
                                            <p className="mb-1">
                                                <strong>Proveedor:</strong> {dataContract.Name1}
                                            </p>

                                            <p className="mb-1">
                                                <strong>NIT:</strong> {dataContract.Nit}
                                            </p>

                                            <p className="mb-1">
                                                <strong>Valor:</strong>{" "}
                                                ${dataContract.ContractAmount?.toLocaleString("es-CO")}
                                            </p>

                                            <p className="mb-1">
                                                <strong>Vigencia:</strong><br />
                                                {dataContract.SeleccionDate || "-"} →{" "}
                                                {dataContract.EndContractDate || "-"}
                                            </p>

                                            <p className="text-muted small mt-2">
                                                {dataContract.Description?.slice(0, 120)}...
                                            </p>

                                            <div className="mt-auto">
                                                <button
                                                    className="btn btn-outline-primary btn-sm w-100"
                                                    onClick={() => {
                                                        _single.setSessionItem("contractSelected", JSON.stringify(dataContract));

                                                        navigateTO("mi-contract-detail")
                                                    }}
                                                >
                                                    Ver detalle
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-md-12">
                                <div className="text-center p-5 rounded-3">
                                    <i className="ri-search-eye-line display-4 text-muted"></i>
                                    <p className="mt-2">Sin Registros de Contratos</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </BasicPage>
    )
}